const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

// Display only. Amounts are decimal strings from the API; never use the
// parsed number for arithmetic.
export const formatUSDC = (value: string | undefined | null): string => {
  const n = Number(value)
  if (!value || !Number.isFinite(n)) return usd.format(0)
  return usd.format(n)
}

export const bipsToPercent = (bips: number): string => (bips / 100).toFixed(2)

export const percentToBips = (percent: string): number | null => {
  if (percent.trim() === '') return null
  const n = Number(percent)
  if (!Number.isFinite(n)) return null
  return Math.round(n * 100)
}

export const formatDate = (iso: string | undefined | null): string => {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleString('en-GB', { timeZone: 'UTC' }) + ' UTC'
}

export const shortId = (id: string): string =>
  id.length <= 14 ? id : `${id.slice(0, 9)}…${id.slice(-4)}`
